import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
const faqs = [{
  question: "Do you offer direct billing for insurance?",
  answer: "Yes, we offer direct billing to most major insurance providers for our Registered Massage Therapy (RMT) services. This helps minimize your out-of-pocket expenses. Please bring your insurance information to your first appointment so we can set it up for you."
}, {
  question: "Is there parking available at the clinic?",
  answer: "Yes, there is convenient paid street parking available directly on Elmhurst Avenue and the surrounding streets. There are also several public parking lots within a short walking distance from our clinic."
}, {
  question: "How close are you to the subway?",
  answer: "We are highly accessible via public transit. Our clinic is just a short, two-minute walk from the Sheppard-Yonge TTC subway station. Simply exit onto Yonge Street and walk north to Elmhurst Avenue."
}, {
  question: "Are your massage therapists registered?",
  answer: "Absolutely. All of our massage therapists are fully registered and in good standing with the College of Massage Therapists of Ontario (CMTO). You can trust that you are receiving care from highly trained and certified professionals."
}];
export default function Faq() {
  return <section id="faq" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-medium text-foreground mb-4 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            Find quick answers to common questions about our clinic location,
            billing policies, and professional services.
          </p>
        </div>

        <div className="bg-muted/40 rounded-3xl p-6 md:p-10 shadow-sm border border-border/50">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
                <AccordionTrigger className="text-left text-lg md:text-xl font-serif font-medium text-foreground hover:no-underline hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed font-sans pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 text-center flex flex-col items-center justify-center gap-6">
          <div className="space-y-2">
            <p className="text-foreground font-medium font-sans text-lg">
              Still have questions?
            </p>
            <p className="text-muted-foreground font-sans">
              Call us directly at 416-938-9900 or send us a message.
            </p>
          </div>
          <Button asChild size="lg" className="rounded-full px-8">
            <Link to="/ContactPage">Contact Our Team</Link>
          </Button>
        </div>
      </div>
    </section>;
}